import { put, takeLatest, select, call } from 'redux-saga/effects';
import types from './types';
import actions from './actions';
import ktRequest from '../../../utils/request';

const getNewMenu = state => state.menus.newMenu;
const getCurrentCenterId = state => state.identity.centerId;

function * createMenu (payload) {
  try {
    const currentCenterId = yield select(getCurrentCenterId);
    const newMenuDetails = yield select(getNewMenu);
    const { dates, entities, name, meals } = newMenuDetails;
    const groupedMeals = yield call(groupMenuMeals, meals);

    const body = {
      dates,
      entities,
      name,
      centerId: currentCenterId,
      meals: groupedMeals
    };

    const response = yield ktRequest.post('menus', body, 'menus');

    if (!response.ok) {
      const json = yield response.json();
      const { error } = json;
      throw new Error(error);
    }

    yield put(actions.createNewMenuSuccess());
  } catch (error) {
    console.log(error);
    yield put(actions.createNewMenuFailure(error.message));
  }
}

/**
 * Group food items of a meal
 * @param {Object[]} meals
 */
function groupMenuMeals (meals) {
  const mealsObject = {};

  meals.forEach(meal => {
    const { food, mealtime } = meal;
    if (mealsObject[mealtime] === undefined) {
      mealsObject[mealtime] = {
        mealtime,
        foods: [food]
      };
    } else {
      let foods = mealsObject[mealtime]['foods'];
      foods.push(food);
      mealsObject[mealtime]['foods'] = foods;
    }
  });

  return Object.values(mealsObject);
}

export const newMenuSagas = [
  takeLatest(types.CREATE_NEW_MENU_REQUEST, createMenu)
];
